module.exports = __webpack_public_path__ + "img/co_bg5.1b2c0efb.png";